import { notification } from 'antd';
import { all, call, put, take } from 'redux-saga/effects';
import {
  LOAD_LOGIN_LIST,
  LOAD_LOGIN_DETAILS,
  ADD_LOGIN,
  UPDATE_LOGIN,
  CHANGE_STATUS_LOGIN,
  CHANGE_PASSWORD_LOGIN,
} from '../type';
import {
  loadLoginListSuccessAction,
  loadLoginListErrorAction,
  loadLoginDetailsSuccessAction,
  loadLoginDetailsErrorAction,
  addLoginSuccessAction,
  addLoginErrorAction,
  updateLoginSuccessAction,
  updateLoginErrorAction,
  changeStatusLoginSuccessAction,
  changeStatusLoginErrorAction,
  changePasswordLoginSuccessAction,
  changePasswordLoginErrorAction,
} from '../action';
import { notifyMessageAction } from 'store/notification/action';

import { manageLoginService, staffService } from 'services';

function* loadLoginList() {
  while (1) {
    const action = yield take(LOAD_LOGIN_LIST);
    try {
      const listLogin = yield call(
        manageLoginService.loadLoginList,
        action.payload,
      );
      yield put(loadLoginListSuccessAction(listLogin));
    } catch (err) {
      yield put(loadLoginListErrorAction(err.message));
      notification.error({
        message: err.message,
      });
    }
  }
}

function* loadLoginDetails() {
  while (1) {
    const action = yield take(LOAD_LOGIN_DETAILS);
    try {
      const listLogin = yield call(
        staffService.loadStaffDetail,
        action.payload,
      );
      yield put(loadLoginDetailsSuccessAction(listLogin));
    } catch (err) {
      yield put(loadLoginDetailsErrorAction(err.message));
      notification.error({
        message: err.message,
      });
    }
  }
}

function* addLogin() {
  while (1) {
    const action = yield take(ADD_LOGIN);
    const {
      payload: { callback },
    } = action;
    try {
      yield call(manageLoginService.adddLogin, action.payload);
      yield put(
        notifyMessageAction({
          message: {
            id: 'app.manage-login.create.success-message',
          },
        }),
      );
      yield put(addLoginSuccessAction());
      if (callback) {
        callback();
      }
    } catch (err) {
      yield put(addLoginErrorAction(err.message));
      notification.error({
        message: err.message,
      });
    }
  }
}

function* updateLogin() {
  while (1) {
    const action = yield take(UPDATE_LOGIN);
    const {
      payload: { callback },
    } = action;
    try {
      yield call(manageLoginService.updateLogin, action.payload);
      yield put(
        notifyMessageAction({
          message: {
            id: 'app.manage-login.update.success-message',
          },
        }),
      );
      yield put(updateLoginSuccessAction());
      if (callback) {
        callback();
      }
    } catch (err) {
      yield put(updateLoginErrorAction(err.message));
      notification.error({
        message: err.message,
      });
    }
  }
}

function* changeStatusLogin() {
  while (1) {
    const action = yield take(CHANGE_STATUS_LOGIN);
    const {
      payload: {
        callback,
        data: { status },
      },
    } = action;
    try {
      yield call(manageLoginService.changeStatusLogin, action.payload);
      let messageId = 'app.manage-login.deactivate.success-message';
      if (status) {
        messageId = 'app.manage-login.activate.success-message';
      }
      yield put(
        notifyMessageAction({
          message: {
            id: messageId,
          },
        }),
      );
      yield put(changeStatusLoginSuccessAction());
      if (callback) {
        callback();
      }
    } catch (err) {
      yield put(changeStatusLoginErrorAction(err.message));
      notification.error({
        message: err.message,
      });
    }
  }
}

function* changePasswordLogin() {
  while (1) {
    const action = yield take(CHANGE_PASSWORD_LOGIN);
    const {
      payload: { callback },
    } = action;
    try {
      yield call(manageLoginService.changePasswordLogin, action.payload);
      yield put(
        notifyMessageAction({
          message: {
            id: 'app.manage-login.change-password.success-message',
          },
        }),
      );
      yield put(changePasswordLoginSuccessAction());
      if (callback) {
        callback();
      }
    } catch (err) {
      yield put(changePasswordLoginErrorAction(err.message));
      notification.error({
        message: err.message,
      });
    }
  }
}

export default function* rootSaga() {
  yield all([
    loadLoginList(),
    loadLoginDetails(),
    addLogin(),
    updateLogin(),
    changeStatusLogin(),
    changePasswordLogin(),
  ]);
}
